import { render, staticRenderFns } from "./RowColRadioHorizontalField.vue?vue&type=template&id=1f596ab8"
import script from "./RowColRadioHorizontalField.vue?vue&type=script&lang=js"
export * from "./RowColRadioHorizontalField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports